export const HEAP_FIND_MY_TICKETS_LINK_SHOWN_EVENT = 'FindMyTicketsLinkShown';
